import React, { useEffect, useState } from 'react';

import { useTranslation } from 'react-i18next';

import config from '@app/config';

import './Footer.scss';

interface YatFooterV2Props {
    wordsCareers?: boolean;
    showCareers?: boolean;
    showDisclosure?: boolean;
    showLicense?: boolean;
}

interface LinkItem {
    label: string;
    href: string;
}
const { jobsLink, privacyLink, supportLink, termsLink, licenseLink, disclosureLink } = config;

/**
 * Adding these options to make this component more reusable
 */
const YatFooterV2 = ({
    showDisclosure = true,
    showLicense = true,
    wordsCareers = true,
    showCareers,
}: YatFooterV2Props) => {
    const { t } = useTranslation(['common', 'words']);

    const [items, setItems] = useState<LinkItem[]>([]);

    useEffect(() => {
        const footerElements: LinkItem[] = [
            {
                label: t('terms_link_privacy_agreement'),
                href: privacyLink,
            },
            {
                label: t('terms_link_terms'),
                href: termsLink,
            },
        ];

        if (showDisclosure) {
            footerElements.push({
                label: t('terms_link_disclosure'),
                href: disclosureLink,
            });
        }

        if (showLicense) {
            footerElements.push({
                label: t('terms_link_nft_license'),
                href: licenseLink,
            });
        }

        // Keeping this here so that the order links show up don't change for existing implementations
        footerElements.push({
            label: t('words:help'),
            href: supportLink,
        });

        setItems(footerElements);
    }, [t, showDisclosure, showLicense]);

    useEffect(() => {
        const careerItem = {
            label: wordsCareers ? t('words:careers') : t('words:jobs'),
            href: jobsLink,
        };
        if (showCareers) {
            setItems((items) => [...items, careerItem]);
        }
    }, [showCareers, wordsCareers, t]);

    return (
        <footer className="yat-footer-v2">
            <ul className="yat-footer-v2__list">
                {items.map((item) => (
                    <li key={`${item.label}-${item.href}`} className="yat-footer-v2__item">
                        <a href={item.href} target="_blank" rel="noopener noreferrer" className="yat-footer-v2__link">
                            {item.label}
                        </a>
                    </li>
                ))}
            </ul>
        </footer>
    );
};

export default YatFooterV2;
